import { Navigate, createBrowserRouter, RouterProvider } from "react-router-dom"

import { AppShell } from "@/components/AppShell"
import { RequireAuth } from "@/components/RequireAuth"
import { CatalogSectionLayout } from "@/layouts/CatalogSectionLayout"
import { CustomersSectionLayout } from "@/layouts/CustomersSectionLayout"
import { InventorySectionLayout } from "@/layouts/InventorySectionLayout"
import { KitchenSectionLayout } from "@/layouts/KitchenSectionLayout"
import { OrdersSectionLayout } from "@/layouts/OrdersSectionLayout"
import { ProductDetailPage } from "@/pages/catalog/ProductDetailPage"
import { ProductsPage } from "@/pages/catalog/ProductsPage"
import { CustomerDetailPage } from "@/pages/customers/CustomerDetailPage"
import { CustomersPage } from "@/pages/customers/CustomersPage"
import { ForbiddenPage } from "@/pages/ForbiddenPage"
import { LotsPage } from "@/pages/inventory/LotsPage"
import { StockPage } from "@/pages/inventory/StockPage"
import { KitchenPackingPage } from "@/pages/kitchen/PackingPage"
import { KitchenPrepPage } from "@/pages/kitchen/PrepPage"
import { KitchenTodayPage } from "@/pages/kitchen/TodayPage"
import { LoginPage } from "@/pages/LoginPage"
import { InvoicePrintPage } from "@/pages/orders/InvoicePrintPage"
import { OrderDetailPage } from "@/pages/orders/OrderDetailPage"
import { OrdersPage } from "@/pages/orders/OrdersPage"
import { WorkOrderPrintPage } from "@/pages/orders/WorkOrderPrintPage"

const router = createBrowserRouter([
  { element: <LoginPage />, path: "/login" },
  { element: <ForbiddenPage />, path: "/forbidden" },
  {
    children: [
      {
        children: [
          { element: <Navigate replace to="/kitchen/today" />, index: true },
          {
            children: [
              { element: <Navigate replace to="/kitchen/today" />, index: true },
              { element: <KitchenTodayPage />, path: "today" },
              { element: <KitchenPrepPage />, path: "prep" },
              { element: <KitchenPackingPage />, path: "packing" },
            ],
            element: <KitchenSectionLayout />,
            path: "kitchen",
          },
          {
            children: [
              { element: <OrdersPage />, index: true },
              { element: <OrderDetailPage />, path: ":orderId" },
            ],
            element: <OrdersSectionLayout />,
            path: "orders",
          },
          { element: <WorkOrderPrintPage />, path: "orders/:orderId/work-order/:date" },
          { element: <InvoicePrintPage />, path: "orders/:orderId/invoice" },
          {
            children: [
              { element: <Navigate replace to="/inventory/stock" />, index: true },
              { element: <StockPage />, path: "stock" },
              { element: <LotsPage />, path: "lots" },
            ],
            element: <InventorySectionLayout />,
            path: "inventory",
          },
          {
            children: [
              { element: <Navigate replace to="/catalog/menu" />, index: true },
              {
                children: [
                  { element: <ProductsPage />, index: true },
                  { element: <ProductDetailPage />, path: ":productId" },
                ],
                path: "menu",
              },
              {
                children: [
                  { element: <ProductsPage />, index: true },
                  { element: <ProductDetailPage />, path: ":productId" },
                ],
                path: "ingredients",
              },
              {
                children: [
                  { element: <ProductsPage />, index: true },
                  { element: <ProductDetailPage />, path: ":productId" },
                ],
                path: "packaging",
              },
              {
                children: [
                  { element: <ProductsPage />, index: true },
                  { element: <ProductDetailPage />, path: ":productId" },
                ],
                path: "kits",
              },
              { element: <Navigate replace to="/catalog/menu" />, path: "products" },
              { element: <ProductDetailPage />, path: "products/:productId" },
            ],
            element: <CatalogSectionLayout />,
            path: "catalog",
          },
          {
            children: [
              { element: <CustomersPage />, index: true },
              { element: <CustomerDetailPage />, path: ":customerId" },
            ],
            element: <CustomersSectionLayout />,
            path: "customers",
          },
        ],
        element: <AppShell />,
      },
    ],
    element: <RequireAuth />,
  },
])

export function App() {
  return <RouterProvider router={router} />
}
